import React from "react";
import packageJson from "../../../package.json";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";


const Version = () => {
    return (
        <Paper sx={{position: 'fixed', bottom: 0, left: 0, right: 0}} elevation={3}>
            <Box sx={{alignContent: 'right', width: '100%'}}>Version: {packageJson.version}</Box>
        </Paper>
    )
}

export default Version;
